<template>
  <div class="history">
    <div class="data">
      <template v-for="(entry, index) in historyFlat">
        <button
          :key="index"
          class="entry"
          :class="statusCode(entry.status)"
          :title="tooltip(entry)"
          @click="handleClick(entry)"
          :disabled="!entry.dateTime"
        >{{month(entry.dateTime)}}</button>
      </template>
    </div>

  </div>
</template>

<script>
import { monthFromDate, toDefaultDate } from "@/assets/lib";

export default {
  props: {
    history: {
      type: Object,
      default: () => {
        return {};
      }
    },
    regId: {
      type: String,
      default: ""
    }
  },
  computed: {
    historyFlat() {
      const entries = Object.values(this.history);
      entries.sort((a, b) => {
        let dateA = toDefaultDate(a.dateTime);
        let dateB = toDefaultDate(b.dateTime);
        return dateA - dateB;
      });
      return entries;
    }
  },
  methods: {
    statusCode(status) {
      const successList = ["success", "initiated", "scheduled", "triggered"];

      if (successList.includes(status)) return "success";
      return status;
    },

    month(date) {
      return monthFromDate(date);
    },

    tooltip(entry) {
      let tip = "";
      if (entry.status) tip += entry.status;
      if (entry.info) tip += " | " + entry.info;
      if (entry.trnId) tip += " | " + entry.trnId;

      return tip;
    },

    handleClick(entry) {
      this.$emit("click", this.regId, entry.trnId, entry.dateTime);
    }
  }
};
</script>

<style>
.history {
  width: 100%;
  position: relative;
}

.history .data {
  position: relative;
  height: 100%;
  width: 100%;
}

.history .entry {
  display: block;
  float: left;
  width: 16.6%;
  height: 1.3rem;
  border: 1px solid #eee !important;
  font-size: 0.7rem;
  color: white;
  border-radius: 3px;
}
.history .entry:hover:enabled {
  opacity: 0.5;
}

.history .blank {
  background: #eee;
}

.history .failed {
  background: #ff3c00;
}
</style>



// WEBPACK FOOTER //
// src/components/history.vue